const CLIENT_IDS = {
  NKO_APP: 'nko-app',
  ORDERS: 'orders-fe',
  NKO_ORDERS: 'nko-orders',
  SETTLEMENTS: 'settlements-fe',
  NKO_SETTLEMENTS: 'nko-settlements',
  LOGS: 'logs-app-fe',
  USERS: 'users-fe',
  SETTINGS: 'settings-fe',
  NKO_SETTINGS: 'nko-settings',
  SELLER: 'seller-fe',
  BRANDING: 'branding-fe',
  LENDING: 'lending-fe',
  UPSTREAM: 'upstream-fe',
  OPTIMIZATION: 'optimization-fe',
  PRODUCTS: 'products-fe',
  HOME: 'home-fe',
  DISPUTES: 'disputes-fe',
  LOGISTICS: 'logistics-fe',
  MARKETING: 'marketing',
  BUSINESS_CARD: 'business-card-fe',
  SUPPORT: 'support'
}

const ENVS = {
  DEVELOPMENT: 'development',
  STAGING: 'staging',
  PLAYGROUND: 'playground',
  PRODUCTION: 'production'
}

const REGIONS = {
  LOCAL: 'local',
  EU: 'eu',
  US: 'us',
  OC: 'oc'
}

export {
  CLIENT_IDS,
  ENVS,
  REGIONS
}
